import { type FC } from 'react';

import styled, { css } from '@mint-lib/styled';

import { Box, IconButton, Truncation } from '@myn/mui';

export const EXPANDER_WIDTH = 140;

type Props = {
  handleFocus: () => void;
  inputValue: string;
  canBeEdited: boolean;
  width: number;
  scale: number;
};

const NameTextField: FC<Props> = ({
  handleFocus,
  inputValue,
  canBeEdited,
  width,
  scale,
}) => {
  return (
    <Wrapper
      onClick={handleFocus}
      $scale={scale}
      width={width}
      canBeEdited={canBeEdited}
    >
      <ResizedTruncation
        variant="bodyLong01"
        tooltipTitle={inputValue}
        $scale={scale}
      >
        {inputValue}
      </ResizedTruncation>
      {canBeEdited && (
        <EditButton
          aria-label="edit"
          className="edit-button"
          variant="icon"
          color="primary"
          size="small"
          icon="Edit"
          onClick={handleFocus}
          $scale={scale}
        />
      )}
    </Wrapper>
  );
};

export default NameTextField;

const Wrapper = styled(Box)<{
  $scale: number;
  width: number;
  canBeEdited: boolean;
}>`
  ${({ $scale, canBeEdited, width, theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    min-width: 100%;
    max-width: ${width * $scale - EXPANDER_WIDTH}px;
    padding: 0 ${8 * $scale}px;
    cursor: ${canBeEdited ? 'pointer' : 'default'};
    color: ${theme.palette.text.link};
    &:hover {
      padding: 0 ${32 * $scale}px 0 ${8 * $scale}px;
      background-color: ${canBeEdited ? theme.palette.ui.hoverCell : 'none'};

      .edit-button {
        display: block;
      }
    }
  `}
`;

const EditButton = styled(IconButton)<{
  $scale: number;
}>`
  display: none;
  position: absolute;
  right: 5px;
  zoom: ${({ $scale }) => $scale};
`;

const ResizedTruncation = styled(Truncation)<{
  $scale: number;
}>`
  display: inline-block;
  font-size: ${({ $scale }) => `${0.875 * $scale}rem`};
  line-height: ${({ $scale }) => 1 * $scale}rem;
`;
